import { render, staticRenderFns } from "./view_UserOrders.vue?vue&type=template&id=4ab40460&scoped=true"
import script from "./view_UserOrders.vue?vue&type=script&lang=js"
export * from "./view_UserOrders.vue?vue&type=script&lang=js"
import style0 from "./view_UserOrders.vue?vue&type=style&index=0&id=4ab40460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab40460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VProgressCircular,VSimpleTable,VSpacer})
